import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
const FIRST_DELAY = 5000;
const SHOW_FOR = 5000;
const GAP = 8000;
const timeLabels = ['Just now', '1 min ago', '2 min ago', '3 min ago', '5 min ago'];
export function PurchasePopup() {
  const [index, setIndex] = useState(() => Math.floor(Math.random() * recentBuyers.length));
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [timeLabel, setTimeLabel] = useState(timeLabels[0]);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let nextTimer: number;
    const show = () => {
      setTimeLabel(timeLabels[Math.floor(Math.random() * timeLabels.length)]);
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        nextTimer = window.setTimeout(() => {
          setIndex(i => (i + 1) % recentBuyers.length);
          show();
        }, GAP);
      }, SHOW_FOR);
    };
    nextTimer = window.setTimeout(show, FIRST_DELAY);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(nextTimer);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-[92px] left-3 right-3 z-50 sm:right-auto sm:max-w-sm" aria-live="polite" data-id="element-259" data-mp="1ay0kzegqoe4z">
      <AnimatePresence data-id="element-260" data-mp="n97n3cgk3w7q">
        {visible && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl border border-brand-100 bg-white p-3 pr-9 shadow-xl" data-id="element-261" data-mp="i93gce5gafup">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-100 text-brand-700" data-id="element-262" data-mp="23nhb25gvziy1">
              <ShoppingBagIcon className="h-5 w-5" aria-hidden="true" data-id="element-263" data-mp="2fne9jhjuourt" />
            </span>
            <div className="min-w-0" data-id="element-264" data-mp="2kmr6iv4fri84">
              <p className="truncate text-sm font-extrabold text-ink" data-id="element-265" data-mp="2knsid1ta08qw">
                {buyer.name} · {buyer.country}
              </p>
              <p className="text-[13px] leading-snug text-muted" data-id="element-266" data-mp="2pl2ef0b67inp">Just purchased the CBCT Decision Map™</p>
              <p className="mt-0.5 text-xs font-semibold text-cta-dark" data-id="element-267" data-mp="1rvz4vi4lq1de">{timeLabel} · Verified purchase</p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-muted transition-colors duration-150 hover:text-ink" aria-label="Close notification" data-id="element-268" data-mp="21wj8grflfhys">
              <XIcon className="h-4 w-4" data-id="element-269" data-mp="195rg651nfdgq" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}